import { toByteArray } from "utf8-to-ansi";
const Buffer = require("buffer/").Buffer;

export function ValidateErrorExportBankForm(employeeList: any, bankId: number) {
  let validateError = false;
  const employeeErrorList: any = [];
  employeeList.forEach((employee: any) => {
    if (employee.bankReferenceId !== bankId) {
      employee.error = true;
      employeeErrorList.push(employee.code);
      validateError = true;
    } else {
      employee.error = false;
    }
  });
  return { employeeErrorList: employeeErrorList, validateError: validateError };
}

export function ValidateErrorEmailSlip(employeeList: any) {
  let validateError = false;
  const employeeErrorList: any = [];
  employeeList.forEach((employee: any) => {
    if (!employee.email) {
      employee.error = true;
      employeeErrorList.push(employee.code);
      validateError = true;
    } else {
      employee.error = false;
    }
  });
  return { employeeErrorList: employeeErrorList, validateError: validateError };
}

export function DownloadUTFBankForm(filename: string, text: string) {
  const element = document.createElement("a");
  element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export async function DownloadANSIBankForm(filename: string, text: string) {
  const element = document.createElement("a");
  const buffer = Buffer.from(toByteArray(text));

  const url = window.URL.createObjectURL(new Blob([buffer], { type: "text/plain" }));

  element.setAttribute("href", url);
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function DownloadFileCSV(filename: string, content: any) {
  const fields = Object.keys(content[0]);
  const replacer = function(key: any, value: any) {
    return value === null ? "" : value;
  };
  let csv: any = content.map(function(row: any) {
    return fields
      .map(function(fieldName) {
        return JSON.stringify(row[fieldName], replacer);
      })
      .join(",");
  });
  csv.unshift(fields.join(",")); // add header column
  csv = csv.join("\r\n");

  const csvString = csv;
  const universalBOM = "\uFEFF";
  const a = window.document.createElement("a");
  a.setAttribute("href", "data:text/csv; charset=utf-8," + encodeURIComponent(universalBOM + csvString));
  a.setAttribute("download", filename + ".csv");
  window.document.body.appendChild(a);
  a.click();
}

function GetRecordType100() {
  const spacebar = " ";
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hh = date.getHours();
  const mm = date.getMinutes();
  const ss = date.getSeconds();
  const recordType100Object = {
    recordTextType: "100",
    batchReference: () => {
      const batchReference = "PEAK-Payroll";
      return batchReference + spacebar.repeat(32 - batchReference.length);
    },
    fileDate: `${year}${month.toString().length == 2 ? month : "0" + month}${
      day.toString().length == 2 ? day : "0" + day
    }`,
    fileTime: `${hh.toString().length == 2 ? hh : "0" + hh}${mm.toString().length == 2 ? mm : "0" + mm}${
      ss.toString().length == 2 ? ss : "0" + ss
    }`,
    channelId: "TBS",
    companyId: spacebar.repeat(12),
    remark: spacebar.repeat(100),
  };

  let recordType100 = "";
  Object.entries(recordType100Object).forEach(([key, value]) => {
    if (typeof value == "string") {
      recordType100 += value;
    } else {
      recordType100 += value();
    }
  });

  return recordType100;
}

function GetRecordType200(netAmountTotal: number, countEmployee: number, paymentDate: string, bankNumber: string) {
  const spacebar = " ";
  const zero = "0";
  const date = new Date(paymentDate);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  let bankAccountNumber = bankNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");
  const recordType200Object = {
    recordTextType: "200",
    productCode: "PAY",
    valueDate: `${year}${month.toString().length == 2 ? month : "0" + month}${
      day.toString().length == 2 ? day : "0" + day
    }`,
    debitAccountNo: () => {
      let debitAccountNo = bankAccountNumber;
      if (debitAccountNo.length > 25) {
        debitAccountNo = debitAccountNo.substr(0, 25);
      }
      return debitAccountNo + spacebar.repeat(25 - debitAccountNo.length);
    },
    debitCurrency: "THB",
    debitAmount: () => {
      let debitAmount: any = netAmountTotal;
      debitAmount = debitAmount.toFixed(2);
      debitAmount = debitAmount.toString().replace(".", "");
      return zero.repeat(16 - debitAmount.toString().length) + debitAmount.toString();
    },
    noOfCredits: () => {
      const noOfCredits: any = countEmployee;
      return zero.repeat(6 - noOfCredits.toString().length) + noOfCredits.toString();
    },
    feeDebitAccount: () => {
      let feeDebitAccount = bankAccountNumber;
      if (feeDebitAccount.length > 25) {
        feeDebitAccount = feeDebitAccount.substr(0, 25);
      }
      return feeDebitAccount + spacebar.repeat(25 - feeDebitAccount.length);
    },
    mediaClearingCycle: spacebar,
    customerDebitReference: spacebar.repeat(20),
    remark: spacebar.repeat(100),
  };

  let recordType200 = "";
  Object.entries(recordType200Object).forEach(([key, value]) => {
    if (typeof value == "string") {
      recordType200 += value;
    } else {
      recordType200 += value();
    }
  });

  return recordType200;
}

function GetRecordType300(detail: any, index: number) {
  const spacebar = " ";
  const zero = "0";
  let bankAccountNumber = detail.bankAccountNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");
  const recordType300Object = {
    recordTextType: "300",
    creditSequenceNumber: () => {
      const creditSequenceNumber: any = index;
      return zero.repeat(6 - creditSequenceNumber.toString().length) + creditSequenceNumber.toString();
    },
    creditAccount: () => {
      let creditAccount = bankAccountNumber;
      if (creditAccount.length > 25) {
        creditAccount = creditAccount.substr(0, 25);
      }
      return creditAccount + spacebar.repeat(25 - creditAccount.length);
    },
    creditAmount: () => {
      let creditAmount = detail.netAmount;
      creditAmount = creditAmount.toFixed(2);
      creditAmount = creditAmount.toString().replace(".", "");
      return zero.repeat(16 - creditAmount.toString().length) + creditAmount.toString();
    },
    creditCurrency: "THB",
    whtPresent: "N",
    invoiceDetailsPresent: "N",
    creditAdviceRequired: "N",
    deliveryMode: "S",
    pickupLocation: spacebar.repeat(4),
    noOfWHTCertificate: zero.repeat(2),
    totalWHTAmount: zero.repeat(16),
    noOfInvoiceDetails: zero.repeat(6),
    totalInvoiceAmount: zero.repeat(16),
    totalVATAmount: zero.repeat(16),
    receivingBankCode: "014",
    receivingBranchCode: zero.repeat(4),
    receivingBranchName: spacebar.repeat(35),
    beneficiaryNotificationFax: "N",
    beneficiaryNotificationSMS: "N",
    beneficiaryNotificationEmail: "N",
    customerReferenceNumber: spacebar.repeat(20),
    chequeReferenceDocumentType: spacebar.repeat(1),
    paymentTypeCode: spacebar.repeat(3),
    servicesType: spacebar.repeat(2),
    beneficiaryCharge: "OUR",
    remarkExtraReference: spacebar.repeat(50),
    promptPayProxyType: spacebar.repeat(3),
    promptPayProxyID: spacebar.repeat(100),
    promptPayBeneficiaryType: spacebar.repeat(2),
    promptPayMessageToBeneficiary: spacebar.repeat(100),
  };

  let recordType300 = "";
  Object.entries(recordType300Object).forEach(([key, value]) => {
    if (typeof value == "string") {
      recordType300 += value;
    } else {
      recordType300 += value();
    }
  });

  return recordType300;
}

function GetRecordType301(detail: any, index: number) {
  const spacebar = " ";
  const zero = "0";
  const recordType301Object = {
    recordTextType: "301",
    creditSequenceNumber: () => {
      let creditSequenceNumber: any = index;
      if (creditSequenceNumber.length > 6) {
        creditSequenceNumber = creditSequenceNumber.substr(0, 6);
      }
      return zero.repeat(6 - creditSequenceNumber.toString().length) + creditSequenceNumber.toString();
    },
    payee1IDCardTaxID: spacebar.repeat(15),
    payee1Name1THEN: () => {
      let payee1Name1THEN = detail.firstNameLocale + spacebar + detail.lastNameLocale;
      if (payee1Name1THEN.length > 140) {
        payee1Name1THEN = payee1Name1THEN.substr(0, 140);
      }
      return payee1Name1THEN + spacebar.repeat(140 - payee1Name1THEN.length);
    },
    payee1Address1: spacebar.repeat(70),
    payee1Address2: spacebar.repeat(70),
    payee1Address3: spacebar.repeat(70),
    payee1NameEnglish: spacebar.repeat(140),
    payeeFaxNumber: spacebar.repeat(15),
    payeeMobilePhoneNumber1: spacebar.repeat(15),
    payeeMobilePhoneNumber2: spacebar.repeat(15),
    payeeMobilePhoneNumber3: spacebar.repeat(15),
    payeeEmailAddress: spacebar.repeat(100),
    payee2NameThai: spacebar.repeat(140),
    payee2Address1: spacebar.repeat(70),
    payee2Address2: spacebar.repeat(70),
    payee2Address3: spacebar.repeat(70),
    remark1: spacebar.repeat(100),
    remark2: spacebar.repeat(100),
  };

  let recordType301 = "";
  Object.entries(recordType301Object).forEach(([key, value]) => {
    if (typeof value == "string") {
      recordType301 += value;
    } else {
      recordType301 += value();
    }
  });

  return recordType301;
}

function GetRecordType999(netAmountTotal: number, countEmployee: number) {
  const zero = "0";
  const recordType999Object = {
    recordTextType: "999",
    totalNoOfDebits: "000001",
    totalNoOfCredits: () => {
      let totalNoOfCredits: any = countEmployee;
      if (totalNoOfCredits.length > 6) {
        totalNoOfCredits = totalNoOfCredits.substr(0, 6);
      }
      return zero.repeat(6 - totalNoOfCredits.toString().length) + totalNoOfCredits.toString();
    },
    totalAmount: () => {
      let totalAmount: any = netAmountTotal;
      totalAmount = totalAmount.toFixed(2);
      totalAmount = totalAmount.toString().replace(".", "");
      if (totalAmount.length > 16) {
        totalAmount = totalAmount.substr(0, 16);
      }
      return zero.repeat(16 - totalAmount.toString().length) + totalAmount.toString();
    },
  };

  let recordType999 = "";
  Object.entries(recordType999Object).forEach(([key, value]) => {
    if (typeof value == "string") {
      recordType999 += value;
    } else {
      recordType999 += value();
    }
  });

  return recordType999;
}

export function CreateContentExportBankSCBForm(employeeList: any, paymentDate: string, settingBankAccount: any) {
  const recordType100 = GetRecordType100();
  let netAmountTotal = 0;
  let content = "";

  employeeList.forEach((employeeItem: any, index: number) => {
    const recordType300 = GetRecordType300(employeeItem, index + 1);
    const recordType301 = GetRecordType301(employeeItem, index + 1);
    netAmountTotal += employeeItem.netAmount;
    content = content + recordType300 + "\n" + recordType301 + "\n";
  });

  const recordType200 = GetRecordType200(
    netAmountTotal,
    employeeList.length,
    paymentDate,
    settingBankAccount.bankNumber
  );
  const recordType999 = GetRecordType999(netAmountTotal, employeeList.length);

  return recordType100 + "\n" + recordType200 + "\n" + content + recordType999;
}

function GetContentHeaderBankKBankForm(
  netAmountTotal: number,
  countEmployee: number,
  paymentDate: string,
  bankNumber: string,
  merchantName: string
) {
  const spacebar = " ";
  const zero = "0";
  let bankAccountNumber = bankNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");
  const headerObject = {
    partIdentifier: "H",
    productType: "PCT",
    batchRef: () => {
      const ref = "PEAK";
      return ref + spacebar.repeat(16 - ref.length);
    },
    transNo: zero.repeat(6),
    filler4: spacebar.repeat(1),
    transType: spacebar.repeat(4),
    filler6: spacebar.repeat(1),
    companyCode: spacebar.repeat(7),
    filler8: spacebar.repeat(1),
    acctNo: () => {
      let acctNo = bankAccountNumber;
      if (acctNo.length > 10) {
        acctNo = acctNo.substr(0, 10);
      }
      return acctNo + spacebar.repeat(10 - acctNo.length);
    },
    filler10: spacebar.repeat(1),
    amount: () => {
      let amount: number | string = netAmountTotal;
      amount = amount.toFixed(2);
      amount = amount.toString().replace(".", "");
      if (amount.length > 15) {
        amount = amount.substr(0, 15);
      }
      return zero.repeat(15 - amount.toString().length) + amount.toString();
    },
    filler11: spacebar.repeat(1),
    transDate: () => {
      const date = new Date(paymentDate);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const transDate = `${year.toString().substr(2, year.toString().length)}${
        month.toString().length == 2 ? month : "0" + month
      }${day.toString().length == 2 ? day : "0" + day}`;
      return transDate;
    },
    filler14: spacebar.repeat(1),
    title: spacebar.repeat(23),
    filler16: spacebar.repeat(1),
    name: () => {
      let name = merchantName;
      if (name.length > 50) {
        name = name.substr(0, 50);
      }
      return name + spacebar.repeat(50 - name.length);
    },
    effectiveDate: () => {
      const date = new Date(paymentDate);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const effectiveDate = `${year.toString().substr(2, year.toString().length)}${
        month.toString().length == 2 ? month : "0" + month
      }${day.toString().length == 2 ? day : "0" + day}`;
      return effectiveDate;
    },
    totalCreditItem: () => {
      const totalCreditItem: number | string = countEmployee;
      return zero.repeat(18 - totalCreditItem.toString().length) + totalCreditItem.toString();
    },
    chargesForACOf: "N",
    customerBranch: spacebar.repeat(5),
  };

  let headerContent = "";
  Object.entries(headerObject).forEach(([key, value]) => {
    if (typeof value == "string") {
      headerContent += value;
    } else {
      headerContent += value();
    }
  });

  return headerContent;
}

function GetContentDetailBankKBankForm(detail: any, index: number, paymentDate: string) {
  const spacebar = " ";
  const zero = "0";
  let bankAccountNumber = detail.bankAccountNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");
  const detailObject = {
    partIdentifier: "D",
    transNo: () => {
      const transNo: string | number = index;
      return zero.repeat(6 - transNo.toString().length) + transNo.toString();
    },
    filler2: spacebar.repeat(1),
    transType: spacebar.repeat(4),
    filler4: spacebar.repeat(1),
    companyCode: spacebar.repeat(7),
    filler6: spacebar.repeat(1),
    acctNo: () => {
      let acctNo: string = bankAccountNumber;
      if (acctNo.length > 10) {
        acctNo = acctNo.substr(0, 10);
      }
      return acctNo + spacebar.repeat(10 - acctNo.length);
    },
    filler8: spacebar.repeat(1),
    amount: () => {
      let amount = detail.netAmount;
      amount = amount.toFixed(2);
      amount = amount.toString().replace(".", "");
      if (amount.length > 15) {
        amount = amount.substr(0, 15);
      }
      return zero.repeat(15 - amount.toString().length) + amount.toString();
    },
    filler10: spacebar.repeat(1),
    transDate: () => {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const transDate = `${year.toString().substr(2, year.toString().length)}${
        month.toString().length == 2 ? month : "0" + month
      }${day.toString().length == 2 ? day : "0" + day}`;
      return transDate;
    },
    filler12: spacebar.repeat(1),
    title: spacebar.repeat(23),
    filler14: spacebar.repeat(1),
    name: () => {
      let name = detail.firstNameLocale + spacebar + detail.lastNameLocale;
      if (name.length > 50) {
        name = name.substr(0, 50);
      }
      return name + spacebar.repeat(50 - name.length);
    },
    effectiveDate: () => {
      const date = new Date(paymentDate);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const effectiveDate = `${year.toString().substr(2, year.toString().length)}${
        month.toString().length == 2 ? month : "0" + month
      }${day.toString().length == 2 ? day : "0" + day}`;
      return effectiveDate;
    },
    taxInfoCount: "000",
    beneRef: () => {
      const ref = "PEAK";
      return ref + spacebar.repeat(16 - ref.length);
    },
    attachmentSubFile: spacebar.repeat(50),
    adviceMode: spacebar.repeat(1),
    faxNo: spacebar.repeat(50),
    emailId: spacebar.repeat(50),
    totalLnvAmtBefVAT: "0000000000.00",
    totalTaxDeductedAmt: "0000000000.00",
    totalLnvAmtAfterVAT: spacebar.repeat(13),
    payeeTaxId: spacebar.repeat(10),
    payeePersonalId: spacebar.repeat(13),
    payeeAddress1: spacebar.repeat(30),
    payeeAddress2: spacebar.repeat(30),
    payeeAddress3: spacebar.repeat(30),
    payeeAddress4: spacebar.repeat(30),
  };

  let detailContent = "";
  Object.entries(detailObject).forEach(([key, value]) => {
    if (typeof value == "string") {
      detailContent += value;
    } else {
      detailContent += value();
    }
  });

  return detailContent;
}

export function CreateContentExportBankKBankForm(
  employeeList: any,
  paymentDate: string,
  settingBankAccount: any,
  merchantName: string
) {
  let content = "";
  let netAmountTotal = 0;

  employeeList.forEach((employeeItem: any, index: number) => {
    const detail = GetContentDetailBankKBankForm(employeeItem, index + 1, paymentDate);
    netAmountTotal += employeeItem.netAmount;
    content += detail + "\n";
  });

  const header = GetContentHeaderBankKBankForm(
    netAmountTotal,
    employeeList.length,
    paymentDate,
    settingBankAccount.bankNumber,
    merchantName
  );

  return (content = header + "\n" + content);
}

function GetHeaderRecordBBLForm(bankNumber: any, paymentDate: any) {
  const spacebar = " ";
  const zero = "0";
  let bankAccountNumber = bankNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");

  const detailObject = {
    recordType: "H",
    sequence: "000001",
    bankCode: "002",
    companyAccountNo: () => {
      let acctNo = bankAccountNumber;
      if (acctNo.length > 10) {
        acctNo = acctNo.substr(0, 10);
      }
      return acctNo + zero.repeat(10 - acctNo.length);
    },
    companyName: spacebar.repeat(25),
    paymentDate: () => {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const transDate = `${day.toString().length == 2 ? day : "0" + day}${
        month.toString().length == 2 ? month : "0" + month
      }${year.toString().substr(2, year.toString().length)}`;
      return transDate;
    },
    spare: zero.repeat(77),
  };

  let detailContent = "";
  Object.entries(detailObject).forEach(([key, value]) => {
    if (typeof value == "string") {
      detailContent += value;
    } else {
      detailContent += value();
    }
  });

  return detailContent;
}

function GetHeaderRecordUOBForm(bankNumber: any, paymentDate: any, merchantName: string, merchantCode: string) {
  const spacebar = " ";
  const zero = "0";
  let bankAccountNumber = bankNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");

  const detailObject = {
    recordType: "H",
    sequence: "000001",
    bankCode: "024",
    companyAccountNo: () => {
      let acctNo = bankAccountNumber;
      if (acctNo.length > 10) {
        acctNo = acctNo.substr(0, 10);
      }
      return acctNo + zero.repeat(10 - acctNo.length);
    },
    companyName: () => {
      if (merchantName.length > 50) {
        merchantName = merchantName.substr(0, 50);
      }
      return merchantName + spacebar.repeat(50 - merchantName.length);
    },
    effectiveDate: () => {
      const date = new Date(paymentDate);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const transDate = `${day.toString().length == 2 ? day : "0" + day}${
        month.toString().length == 2 ? month : "0" + month
      }${year.toString()}`;
      return transDate;
    },
    companyCode: () => {
      if (merchantCode.length > 9) {
        merchantCode = merchantCode.substr(0, 9);
      }
      return merchantCode + zero.repeat(9 - merchantCode.length);
    },
    filler: spacebar.repeat(41),
  };

  let detailContent = "";
  Object.entries(detailObject).forEach(([key, value]) => {
    if (typeof value == "string") {
      detailContent += value;
    } else {
      detailContent += value();
    }
  });

  return detailContent;
}

function GetContentDetailBankBBLForm(detail: any, index: number) {
  const spacebar = " ";
  const zero = "0";
  const sequence: any = index;
  const netAmount = detail.netAmount;
  const customerName = detail.firstNameLocale + spacebar + detail.lastNameLocale;
  let bankAccountNumber = detail.bankAccountNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");

  const detailObject = {
    recordtype: "D",
    sequence: zero.repeat(6 - sequence.toString().length) + sequence.toString(),
    bankCode: "002",
    accountNo: () => {
      let acctNo = bankAccountNumber;
      if (acctNo.length > 10) {
        acctNo = acctNo.substr(0, 10);
      }
      return acctNo + zero.repeat(10 - acctNo.length);
    },
    transactionCode: "C",
    amount: () => {
      let amount: any = netAmount;
      amount = amount.toFixed(2);
      amount = amount.toString().replace(".", "");
      return zero.repeat(10 - amount.toString().length) + amount.toString();
    },
    serviceType: "02",
    status: "9",
    spare: zero.repeat(32),
    departmentCode: zero.repeat(4),
    user: zero.repeat(10),
    spare2: zero.repeat(13),
    customerName: () => {
      let customerNameMock = customerName;
      if (customerNameMock.length > 35) {
        customerNameMock = customerNameMock.substr(0, 35);
      }
      return customerNameMock + spacebar.repeat(35 - customerNameMock.length);
    },
  };

  let detailContent = "";
  Object.entries(detailObject).forEach(([key, value]) => {
    if (typeof value == "string") {
      detailContent += value;
    } else {
      detailContent += value();
    }
  });

  return detailContent;
}

function GetContentDetailBankUOBForm(detail: any, index: number) {
  const spacebar = " ";
  const zero = "0";
  const sequence: any = index;
  let employeeCode = detail.code;
  const netAmount = detail.netAmount;
  const customerName = detail.firstNameLocale + spacebar + detail.lastNameLocale;
  let bankAccountNumber = detail.bankAccountNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");

  const detailObject = {
    recordtype: "D",
    sequence: zero.repeat(6 - sequence.toString().length) + sequence.toString(),
    bankCode: "024",
    accountNo: () => {
      let acctNo = bankAccountNumber;
      if (acctNo.length > 10) {
        acctNo = acctNo.substr(0, 10);
      }
      return acctNo + zero.repeat(10 - acctNo.length);
    },
    transactionCode: "C",
    amount: () => {
      let amount: any = netAmount;
      amount = amount.toFixed(2);
      amount = amount.toString().replace(".", "");
      if (amount.length > 10) {
        amount = amount.substr(0, 10);
      }
      return zero.repeat(10 - amount.toString().length) + amount.toString();
    },
    serviceType: "20",
    statusFlag: "9",
    empID: () => {
      if (employeeCode.length > 15) {
        employeeCode = employeeCode.substr(0, 15);
      }
      return employeeCode + spacebar.repeat(15 - employeeCode.length);
    },
    empName: customerName + spacebar.repeat(50 - customerName.length),
    filler: spacebar.repeat(28),
  };

  let detailContent = "";
  Object.entries(detailObject).forEach(([key, value]) => {
    if (typeof value == "string") {
      detailContent += value;
    } else {
      detailContent += value();
    }
  });

  return detailContent;
}

function GetTotalBankBBLForm(employeeLength: any, bankNumber: any, netAmountTotal: any) {
  const spacebar = " ";
  const zero = "0";
  let bankAccountNumber = bankNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");

  const detailObject = {
    recordtype: "T",
    sequence: () => {
      const sequence = employeeLength + 2;
      return zero.repeat(6 - sequence.toString().length) + sequence.toString();
    },
    bankCode: "002",
    companyAccountNo: () => {
      let acctNo = bankAccountNumber;
      if (acctNo.length > 10) {
        acctNo = acctNo.substr(0, 10);
      }
      return acctNo + zero.repeat(10 - acctNo.length);
    },
    deductionTransaction: zero.repeat(7),
    totalDeductionAmount: zero.repeat(13),
    depositTransaction: zero.repeat(7 - employeeLength.toString().length) + employeeLength.toString(),
    totalDepositAmount: () => {
      let amount = netAmountTotal;
      amount = amount.toFixed(2);
      amount = amount.toString().replace(".", "");
      if (amount.length > 13) {
        amount = amount.substr(0, 13);
      }
      return zero.repeat(13 - amount.toString().length) + amount.toString();
    },
    spare: zero.repeat(68),
  };
  let detailContent = "";
  Object.entries(detailObject).forEach(([key, value]) => {
    if (typeof value == "string") {
      detailContent += value;
    } else {
      detailContent += value();
    }
  });

  return detailContent;
}

function GetTotalBankUOBForm(employeeLength: any, bankNumber: any, netAmountTotal: any) {
  const spacebar = " ";
  const zero = "0";
  let bankAccountNumber = bankNumber.replace(/-/g, "");
  bankAccountNumber = bankAccountNumber.replace(/ /g, "");

  const detailObject = {
    recordtype: "T",
    sequence: () => {
      const sequence = employeeLength + 2;
      return zero.repeat(6 - sequence.toString().length) + sequence.toString();
    },
    bankCode: "024",
    companyAccountNo: () => {
      let acctNo = bankAccountNumber;
      if (acctNo.length > 10) {
        acctNo = acctNo.substr(0, 10);
      }
      return acctNo + zero.repeat(10 - acctNo.length);
    },
    transectionTotal: zero.repeat(7 - employeeLength.toString().length) + employeeLength.toString(),
    amountTotal: () => {
      let amount = netAmountTotal;
      amount = amount.toFixed(2);
      amount = amount.toString().replace(".", "");
      if (amount.length > 13) {
        amount = amount.substr(0, 13);
      }
      return zero.repeat(13 - amount.toString().length) + amount.toString();
    },
    spare: spacebar.repeat(73),
    reservedField: zero.repeat(15),
  };

  let detailContent = "";
  Object.entries(detailObject).forEach(([key, value]) => {
    if (typeof value == "string") {
      detailContent += value;
    } else {
      detailContent += value();
    }
  });

  return detailContent;
}

export function CreateContentExportBankBBLForm(employeeList: any, paymentDate: string, settingBankAccount: any) {
  const header = GetHeaderRecordBBLForm(settingBankAccount.bankNumber, paymentDate);

  let content = "";
  let netAmountTotal = 0;

  employeeList.forEach((employeeItem: any, index: number) => {
    const detail = GetContentDetailBankBBLForm(employeeItem, index + 2);
    netAmountTotal += employeeItem.netAmount;
    content += detail + "\n";
  });

  const total = GetTotalBankBBLForm(employeeList.length, settingBankAccount.bankNumber, netAmountTotal);

  return header + "\n" + content + total;
}

export function CreateContentExportBankUOBForm(
  employeeList: any,
  paymentDate: string,
  settingBankAccount: any,
  merchantName: string,
  merchantCode: string
) {
  const header = GetHeaderRecordUOBForm(settingBankAccount.bankNumber, paymentDate, merchantName, merchantCode);

  let content = "";
  let netAmountTotal = 0;

  employeeList.forEach((employeeItem: any, index: number) => {
    const detail = GetContentDetailBankUOBForm(employeeItem, index + 2);
    netAmountTotal += employeeItem.netAmount;
    content += detail + "\n";
  });

  const total = GetTotalBankUOBForm(employeeList.length, settingBankAccount.bankNumber, netAmountTotal);

  return header + "\n" + content + total;
}

export function CreateContentExportBankKBOLForm(employeeList: any) {
  const data: any = [];

  employeeList.forEach((employeeItem: any, index: number) => {
    const bankAccountNumber = employeeItem.bankAccountNumber.replace(/-/g, "");
    const customerName = employeeItem.firstNameLocale + " " + employeeItem.lastNameLocale;
    let amount: any = employeeItem.netAmount;
    amount = amount.toFixed(2);
    const detail = {
      accountNo: bankAccountNumber.toString(),
      promptPayID: "",
      accountName: customerName,
      amount: amount,
      description: employeeItem.code.toString(),
    };
    data.push(detail);
  });

  return data;
}

function Base64ToArrayBuffer(base64: any) {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}
export function DownloadExport(data: any) {
  const a = window.document.createElement("a");
  a.href = window.URL.createObjectURL(
    new Blob([Base64ToArrayBuffer(data.dataByte)], { type: "application/octet-stream" })
  );
  a.download = data.fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
